var _path, _rect, _circle, _ellipse, _path2, _circle2, _ellipse2, _path3, _rect2, _ellipse3, _ellipse4, _circle3, _path4, _polygon, _path5, _path6, _circle4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon2, _polygon3, _polygon4, _path17, _path18, _path19, _path20, _circle5, _path21, _polygon5, _path22, _path23, _path24, _path25, _path26, _path27, _ellipse5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 888.84817,
    height: 728.46381,
    viewBox: "0 0 888.84817 728.46381",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "date_night") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.69435,768.82832c16.0246,9.64093,22.19618,28.79047,22.19618,28.79047s-19.80943,3.51851-35.834-6.12242-22.19618-28.79047-22.19618-28.79047S179.66975,759.18739,195.69435,768.82832Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#ef4757"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 549.56588,
    y: 70.28152,
    width: 9.47616,
    height: 588.14964,
    fill: "#d0cde1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 421.51357,
    cy: 85.28544,
    r: 18.95232,
    fill: "#ef4757"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.09293,
    cy: 71.86088,
    rx: 52.90856,
    ry: 8.68648,
    fill: "#d0cde1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M714.4938,156.04961h-9.47616a60.80536,60.80536,0,0,0-121.61072,0h-9.47616a70.28152,70.28152,0,0,1,140.563,0Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#d0cde1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.84604,
    cy: 85.28544,
    r: 18.95232,
    fill: "#ef4757"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 685.26668,
    cy: 71.86088,
    rx: 52.90856,
    ry: 8.68648,
    fill: "#d0cde1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M705.01764,156.04961h9.47616a60.80536,60.80536,0,1,1,121.61072,0h9.47616a70.28152,70.28152,0,0,0-140.563,0Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#d0cde1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 536.65643,
    y: 615.16071,
    width: 35.04675,
    height: 44.22208,
    fill: "#d0cde1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.09218,
    cy: 714.75796,
    rx: 261.09218,
    ry: 4.64662,
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.51627,
    cy: 659.67905,
    rx: 213.3319,
    ry: 4.64662,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.31502,
    cy: 335.32664,
    r: 28.38465,
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M495.23783,593.03587l4.30342,8.60685s13.771,22.37781,4.30342,24.95986-12.47993-16.78335-12.47993-16.78335L489.64337,599.491Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#a0616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "322.448 463.373 333.207 491.775 343.965 511.571 330.625 520.178 319.866 501.243 306.956 471.549 322.448 463.373",
    fill: "#d0cde1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M447.46981,682.11676l-21.51712,22.80816-37.87014,64.121-16.353-5.1641L391.095,725.58135s11.1889-29.26328,16.78335-33.13637,15.062-29.26328,15.062-29.26328l10.32822-8.17651Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M491.79509,694.5967l1.72137,7.31582s5.59445,22.80815,14.2013,33.13637l20.65644,35.71842,15.49233-5.1641-30.55432-72.29754Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#a0616a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.15866,
    cy: 345.24383,
    r: 23.23849,
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M441.445,442.416l-3.0124,24.95987L457.798,476.8434s0-21.51712,5.16411-27.11157Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M380.76673,603.36409l-2.15172,7.31582s-14.2013,27.97226-2.15171,27.97226,14.2013-25.82054,14.2013-25.82054l1.291-6.45514Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M479.7455,574.1008l-3.0124,21.08678,36.57911,77.03131,2.15171,22.37781-68.42445,8.60685-15.062-41.74322L407.8783,692.445l13.771-31.84534s4.30343-21.51712,3.0124-27.11158.86068-33.56671,4.73377-40.45219S479.7455,574.1008,479.7455,574.1008Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M390.6646,769.04594l-20.65644-6.88547L363.553,772.48868s-12.47994,3.44274-12.04959,12.47994-2.15172,24.52952-2.15172,24.52952l9.0372.86068,3.44274-17.644,17.644,21.08678s31.415,1.72137,32.706-3.44274-22.37781-10.75856-22.37781-10.75856l-3.87308-18.50473Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M545.15755,763.02115l-18.93507,6.02479v4.30343s-5.59445,8.60685-4.73376,15.92267,4.73376,24.95987,4.73376,24.95987h9.89788l-.43034-16.353,19.79575,16.353s35.28809-2.58206,35.28809-8.17651-27.11158-9.46754-27.11158-9.46754Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M459.08906,471.67929s-17.644-17.644-25.82055-13.34061v7.74616s-12.04959,5.59445-12.47993,14.2013-12.91028,86.92918-12.91028,86.92918L378.615,669.20649s9.0372,14.2013,42.17357-1.72137L441.445,597.3393s-21.94747,79.183-11.18891,77.892,52.93213-99.40911,52.93213-99.40911l-3.0124-46.477s6.88548-20.22609-6.88548-33.997Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#d0cde1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M428.96508,474.26135s-7.31582,2.582-12.47993,13.771-30.98466,89.94157-30.98466,89.94157L378.615,605.94615l19.36542,4.73376L407.448,581.847,442.736,516.43491S448.3305,482.00751,428.96508,474.26135Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#d0cde1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M430.66569,412.47313c.43522-5.312,2.9784-10.75689,7.68179-13.26392-2.36174-4.7437-4.47251-10.15812-2.91562-15.22335a11.61807,11.61807,0,0,1,8.75226-7.83159,22.8019,22.8019,0,0,1,6.8.088l10.604,1.20275c3.44012.39019,7.01294.8255,9.93886,2.67635a11.51284,11.51284,0,0,1,1.32968,18.47775c7.41912,5.93436,12.3772,10.43916,15.75295,19.31972-6.18613-4.9801-12.10653-6.74372-20.03655-7.17294a19.09856,19.09856,0,0,0-20.066,17.49941c-.20457,2.47809.06884,5.02981-.65232,7.40946s-2.894,4.60917-5.35607,4.26148c.34146.04822,2.44362-6.26415.9637-9.17782l-.02321-.04692a2.7733,2.7733,0,0,0-1.507-1.29305,4.34005,4.34005,0,0,0-5.769,3.01835c-.82319,3.16155-2.14042,7.19569-3.291,6.12486-1.50676-1.40236-.87289-13.76736-1.27948-15.68422A35.99,35.99,0,0,1,430.66569,412.47313Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M438.46421,399.12432s23.32309,1.52107,34.47762-.507",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#d0cde1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M439.78689,396.0035c-2.36184-4.7437-4.47257-10.1581-2.91563-15.22334a11.5,11.5,0,0,1,4.0684-5.71864,11.64491,11.64491,0,0,0-6.22011,7.00967c-1.557,5.06524.55379,10.47964,2.91563,15.22334C439.50847,397.01487,435.08349,398.51054,439.78689,396.0035Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "291.679 430.882 258.112 490.269 245.202 522.545 263.276 491.56 291.679 430.882",
    opacity: 0.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "765.076 622.802 768.157 644.368 783.562 642.827 782.021 620.491 765.076 622.802",
    fill: "#ffb8b8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "691.905 622.802 688.824 644.368 673.419 642.827 674.96 620.491 691.905 622.802",
    fill: "#ffb8b8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M825.14413,485.20394S811.28005,501.3787,814.361,526.79618s8.4725,83.18448,8.4725,83.18448l3.85113,102.44015,24.64725-1.54046,3.85114-87.03561,12.32362-70.09063,33.11975,81.644s16.17476,76.25244,16.945,76.25244,23.1068-2.31068,23.1068-2.31068L929.895,619.22338S912.95,488.28484,902.937,485.97416,825.14413,485.20394,825.14413,485.20394Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M940.67813,725.51466s-13.86408-9.24272-19.25567,1.54045-.77023,18.48544-.77023,18.48544,4.62136,3.08091,2.31068,6.16182-3.0809,23.1068,16.945,20.02589,10.01295-23.877,10.01295-23.877Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M827.45481,725.51466s13.86408-9.24272,19.25566,1.54045.77023,18.48544.77023,18.48544-4.62136,3.08091-2.31068,6.16182,3.08091,23.1068-16.945,20.02589-10.01294-23.877-10.01294-23.877Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M844.01468,335.39485s6.932,19.25566,1.54045,30.03884,8.4725,23.1068,8.4725,23.1068,36.20065-18.48544,31.57929-27.72816-12.32363-21.56635-10.78317-29.26862Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#ffb8b8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 701.91773,
    cy: 232.29665,
    r: 24.64725,
    fill: "#ffb8b8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M839.77843,364.27835s24.73047,20.57917,43.17431-8.581L902.16679,366.589l10.013,117.07445s-56.22655,32.34952-83.18448,4.62136l3.85113-108.602Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#ef4757"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "691.969 266.982 657.245 290.064 669.568 347.06 653.393 435.636 679.581 396.355 691.969 266.982",
    fill: "#575a89"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M878.23373,346.32555l8.52853,5.62917,34.6602,12.32363-5.39159,95.50811,14.63431,61.61813-20.79612,10.78317s-3.85113-29.26861-27.72816-43.90292S872.78611,350.70933,878.23373,346.32555Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#575a89"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M820.52277,495.98711l10.01294,6.932s-12.70874,13.479-15.01942,11.16829a6.31563,6.31563,0,0,1-1.92556-5.00648l-2.31068-5.39158Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#ffb8b8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M887.08548,494.48869l-3.40413,5.34955s-10.01294,4.62136-7.70226,7.70227,21.56634,10.01295,25.41748,3.08091l3.85113-6.932Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#ffb8b8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M817.44186,375.06152l-5.39159.77023-8.8576,57.38189s-3.466,10.39806.38511,35.04531,7.66481,40.697,7.66481,40.697L828.225,496.75734l-7.70226-20.0259,10.01294-73.17153Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#575a89"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M909.09883,362.73789l12.32363,1.54046s13.86408,14.63431,16.17476,30.03884,1.54046,59.30745,1.54046,59.30745l-35.43043,56.22655-19.25567-13.86408,26.95793-47.754-13.09385-56.99678Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#575a89"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M880.99739,295.77264a28.794,28.794,0,0,0-16.37911-12.52146l-5.00775,4.00618,1.94692-4.67276a26.50688,26.50688,0,0,0-4.9495-.28606l-4.50569,5.79307,1.86485-5.59464a28.5187,28.5187,0,0,0-19.67355,11.70238c-5.73466,8.26884-6.70231,19.76814-1.062,28.10164,1.54833-4.75814,3.42753-9.22288,4.97586-13.98107a14.08421,14.08421,0,0,0,3.66859.01787l1.88379-4.3954.52619,4.20949c5.83864-.50872,14.49879-1.62547,20.034-2.64873l-.53821-3.22927,3.2202,2.68352c1.6959-.39044,2.70276-.74443,2.61956-1.015,4.11668,6.63658,8.19567,10.87551,12.31224,17.512C883.49647,312.09335,886.25515,304.31211,880.99739,295.77264Z",
    transform: "translate(-155.57591 -85.76809)",
    fill: "#2f2e41"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 724.05665,
    cy: 231.52232,
    rx: 1.6685,
    ry: 3.33701,
    fill: "#ffb8b8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.0b2745267b07bfec49819ece387344d1.svg";
export { ForwardRef as ReactComponent };